import { render, staticRenderFns } from "./createPatient.vue?vue&type=template&id=5e8b894c&"
import script from "./createPatient.vue?vue&type=script&lang=js&"
export * from "./createPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports